export enum HttpsStatusCode {
  // 2xx Success
  OK = 200,

  // 4xx Client Error
  Unauthorized = 401,
  NotFound = 404,

  // 5xx Server Error
  InternalServerError = 500,
  ServiceUnavailable = 503,
}
